import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './DataBlockDropzone.module.css';

const bindClasses = classNameBind.bind(styles);

const DataBlockDropzone = ({
  text,
  type,
  width,
  marginHorizontal,
  marginVertical,
  doubleHeight,
  subdued,
  dataId,
}) => (
  <div className={bindClasses('area', width)} data-ppuc-id={dataId}>
    <div className={
      bindClasses('wrapper', `type-${type}`, `margin-h-${marginHorizontal}`,
        `margin-v-${marginVertical}`, { doubleHeight, subdued })}
    >
      <div className={bindClasses('content')} data-ppuc-id={`${dataId}.text`}>{text}</div>
    </div>
  </div>
);

DataBlockDropzone.defaultProps = {
  width: 'full',
  marginHorizontal: 'none',
  marginVertical: 'none',
  doubleHeight: false,
  subdued: false,
  dataId: 'DataBlockDropzone',
};

export default DataBlockDropzone;
